<template>
  <div class="queryOrder_page">
    <div class="container">
      <div class="row">
        <div class="queryOrder__topCon">
          <div class="queryOrder__topCon_line"></div>
          <span class="queryOrder_txtDarkBlue">官方平台船票订单查询</span>
          <div class="queryOrder__topCon_line"></div>
        </div>
        <div class="queryOrder__mainCon">
          <div class="queryOrder__mainCon_title" style="padding-bottom: 17px;">
            <p style=" height: 20px;">通过船票订单查询您可以：</p>
            <p style="font-size: 12px; height: 10px;">*可查看订单详情并进行在线支付</p>
            <p style="font-size: 12px; height: 10px;">*可绑定皇家加勒比国际游轮飞猪旗舰店，皇家加勒比游轮抖音店铺等官方平台的中国母港往返的航线订单，查看订单详情</p>
            <p style="font-size: 12px; height: 10px;">*为已有订单预订岸上观光行程（仅限中国出发航线订单）</p>
            <p style="font-size: 12px; height: 10px;">*可将电话订单转为线上订单，在线查看详情并支付</p>
            <p style="font-size: 12px; height: 10px;">温馨提示：</p>
            <p style="font-size: 12px; height: 10px;">关联船票后，您可访问该订单下其他乘客的个人信息；办理在线登船手续；查看和修改订单信息；以及预订行前订产品</p>
          </div>
          
          <form id="queryOrder__form">
            <ul>
              <li class="order-box">
                <div class="order-box-item">
                  <div class="order-box-item-title">订单查询</div>
                  <!-- <div class="order-box-item-right">
                    <a
                        :href="toRowPage"
                         target="_blank">
                      查看历史订单>
                    </a>
                    <div>
                      2026-01-09之前预订
                    </div>

                  </div>-->
                </div>
              </li>
              <li class="margin-top-0">
                <div class="queryOrder__mainCon_input">
                  <p><span class="queryOrder__mainCon_red"> * </span>船票订单号：</p>
                  <input name="BookingId" class="queryOrder__mainCon_orderNum" v-model="bookingId" placeholder="不足7位请补0，例: 0012345">
                </div>
              </li>
              <li>
                <div class="queryOrder__mainCon_input">
                  <p><span class="queryOrder__mainCon_red"> * </span>姓（拼音）：</p>
                  <input name="LastName"
                  placeholder="例如：LI" id="queryOrder__mainCon_lastName"
                  :value="lastName" @input="inputValueUpper"
                  >
                </div>
                <p class="queryOrder__mainCon_liCare" id="lastNameInfo" style="color:#777;">该舱房任意乘客拼音（姓）</p>
              </li>

              <li>
                <div class="queryOrder__mainCon_input">
                  <p>
                    <span class="queryOrder__mainCon_red"> * </span>出生日期：</p>
                  <input name="DateOfBirth" class="queryOrder__mainCon_date" readonly="readonly" v-model="DateOfBirth"
                         @focus="isCalendarShowBir=true">
                </div>
                <p class="queryOrder__mainCon_liCare" id="lastNameInfo" style="color:#777;">上述乘客对应的出生日期</p>

                <RcclCalendar
                    class="guestInfo-calender"
                    v-if="isCalendarShowBir"
                    :allowPreYear="true"
                    :defaultDate="today"
                    v-on:onDateClicked="sailDateChangedBir"
                    :maxAge="100"
                />

              </li>

              <li>
                <div class="queryOrder__mainCon_input queryOrder__shipSelect" style="position:relative;">
                  <p><span class="queryOrder__mainCon_red"> * </span>所乘游轮：</p>
                  <select name="ShipCode" id="queryOrder__ship" v-model="shipCode">
<!--                    <option value="WN">海洋奇迹号</option>-->
                    <option :value="item.value" v-for="item in shipOrderList" :key="item.value">{{item.lable}}</option>
                    <!-- <option value="OV">海洋赞礼号</option> -->
<!--                    <option value="QN">海洋量子号</option>-->
<!--                    <option value="VY">海洋航行者号</option>-->
                  </select>
                </div>
              </li>
              <li>
                <div class="queryOrder__mainCon_input">
                  <p>
                    <span class="queryOrder__mainCon_red"> * </span>出航日期：</p>
                  <input name="SailDate" class="queryOrder__mainCon_date" readonly="readonly" v-model="sailDate"
                         @focus="isCalendarShow=true">

                </div>
                <RcclCalendar
                    class="guestInfo-calender"
                    v-if="isCalendarShow"
                    :allowPreYear="false"
                    :defaultDate="today"
                    v-on:onDateClicked="sailDateChanged"
                    :maxYear="3"
                />

              </li>
            </ul>

            <!--二维码-->
            <div class="queryOrder__Wechat">
              <p>欢迎关注皇家加勒比官方微信公众号</p>
              <div class="queryOrder__WechatPic">
                <img src="https://resource.rcclchina.com.cn/bookingPay/Wechat.jpeg">
              </div>
            </div>
          </form>
          <p class="queryOrder__mainCon_attention">带<span class="queryOrder__mainCon_red">*</span>号的为必填</p>

          <div id="bookingSearchCaptchaSubmit" class="queryOrder__mainCon_submit">提交资料</div>
        </div>
      </div>
    </div>

    <ALiYunCaptcha ref="aLiYunCaptchaRef"
                   :initPlugin="initPlugin"
                   :captchaReset="captchaReset"
                   trigger-element="#bookingSearchCaptchaSubmit"
                   @captchaSuccess="onCaptchaSuccess"
                   @captchaFail="onCaptchaFail"
                   @captchaReset="onCaptchaReset"></ALiYunCaptcha>
  </div>
</template>

<script>
import moment from 'moment'
import api from '@/api'
import bookingHelper from '@/utilities/bookingHelper'
const RcclCalendar = () => import('@/components/Common/RcclCalendar.vue')
const ALiYunCaptcha = () => import('@/components/Plugin/ALiYunCaptcha.vue')
export default {
  name: "BookingSearch",
  components: {
    RcclCalendar,
    ALiYunCaptcha
  },
  data() {
    return {
      lastName: '',
      shipCode: 'SC',
      sailDate: '',
      bookingId: '',
      DateOfBirth: '',
      loginCallback: null,
      isCalendarShow: false,
      isCalendarShowBir: false,
      shipOrderList:[
        {
            value:'SC',
            lable:'海洋光谱号'
          },
          {
            value:'OV',
            lable:'海洋赞礼号'
          },
          {
            value:'SY',
            lable:'海洋交响号'
          },
          {
            value:'HM',
            lable:'海洋和悦号'
          },
          {
            value:'AL',
            lable:'海洋魅丽号'
          },
          {
            value:'OA',
            lable:'海洋绿洲号'
          },
          {
            value:'MA',
            lable:'海洋水手号'
          },
          {
            value:'VY',
            lable:'海洋航行者号'
          },
          {
            value:'EX',
            lable:'海洋探险者号'
          },
          {
            value:'NV',
            lable:'海洋领航者号'
          },
          {
            value:'JW',
            lable:'海洋珠宝号'
          },
          {
            value:'QN',
            lable:'海洋量子号'
          },
          
          {
            value:'RD',
            lable:'海洋灿烂号'
          },
          {
            value:'OY',
            lable:'海洋奥德赛号'
          },
          {
            value:'IC',
            lable:'海洋标志号'
          },
          {
            value:'WN',
            lable:'海洋奇迹号'
          },
          {
            value:'AN',
            lable:'海洋圣歌号'
          },
          {
            value:'SR',
            lable:'海洋旋律号'
          },
          {
            value:'UT',
            lable:'海洋乌托邦号'
          },
          {
            value:'BR',
            lable:'海洋光辉号'
          },
          {
            value:'LE',
            lable:'海洋神话号'
          },
          {
            value:'ST',
            lable:'海洋星际号'
          },
          {
            value:'ID',
            lable:'海洋独立号'
          },
          {
            value:'HE',
            lable:'海洋英雄号'
          },
        ],
        toRowPage:`${
        process.env.VUE_APP_BASE_URL
      }/Rccl.Campaign/RedirectToTui?redirectUrl=${process.env.VUE_APP_TUI_URL}/UserCenter/OrderRecord`,
      // 验证
      initPlugin: "",
      isCaptchaAllow: false,
      captchaReset: "",
      captchaVerifyParam: ""
    }
  },
  mounted() {
    const timer = setTimeout(()=> {
      clearTimeout(timer)
      this.initPlugin = (new Date()).getTime().toString();
    },100)

    this.goToLogin();
  },
  methods: {
    // 强制小写转大写
    inputValueUpper(event) {
      this.lastName = event.target.value.toUpperCase();
    },
    async submitBookingSearch() {
      if (!this.isCaptchaAllow) return;
      if (!this.lastName || !this.lastName.trim()) {
        this.$alert.show('请输入姓(拼音)')
        return
      }
      const lastName = this.lastName.trim()
      if (!this.pyNameCheck(lastName)) {
        this.$alert.show('请输入正确的姓(拼音)')
        return
      }
      if (lastName.length < 2) {
        this.$alert.show('姓(拼音)至少输入2个字母')
        return
      }
      if (this.bookingId.trim() == '') {
        this.$alert.show('请输入订单号')
        return
      }
      if (this.sailDate.trim() == '') {
        this.$alert.show('请选择出航日期')
        return
      }
      if (this.DateOfBirth.trim() == '') {
        this.$alert.show('请选择上述乘客对应的出生日期')
        return
      }
      let bookingId = this.fixBookingId();
      const requestData = {
        bookingId: bookingId.trim(),
        lastName: this.lastName.trim(),
        sailDate: this.sailDate,
        DateOfBirth: this.DateOfBirth,
        shipCode: this.shipCode,
        agencyId: bookingHelper.agencyId,
        sceneId: window.ALI_CAPTCHA_SCENE_ID,
        captchaVerifyParam: this.captchaVerifyParam
      }
      this.$loading.show()
      const {success, errMsg,data} = await api.booking.bookingSearch(requestData)
      this.$loading.hide()
      if (!success) {
        if (errMsg == 'USER_LOGIN_ERROR') {
          return this.goToLogin()
        } else if (errMsg == 'NvcNc' || errMsg == 'Block') {
          return false;
        }
        this.$alert.show(errMsg)
        return
      }
      // 详情使用加密的bookingId
      this.$router.push({
        name: 'BookingDetail', query: {
          bookingId:data.code
        }
      })
    },
    fixBookingId () {
      if (!this.bookingId || this.bookingId.length == 0) {
        return '';
      }
      let bookingId = this.bookingId + '';
      if (bookingId.length >= 7) return bookingId;
      while (bookingId.length < 7) {
        bookingId = "0" + bookingId;
      }
      return bookingId;
    },
    goToLogin() {
      const userToken = this.$store.state.user.userToken
      if (!userToken || userToken.length == 0) {
        this.$confirm.show("您尚未登录，请登录之后，再查询订单", {
          confirmCallBack: () => {
            this.$router.push(`/Orchard.Rccl.Users/Login/Login?returnUrl=${encodeURIComponent(location.href)}`)
          }
        });
        return false;
      }
      return true;
    },
    goToRow() {
      location.href = this.rowSearchLink
    },
    pyNameCheck(pyName) {
      //中文验证
      if (!/^[A-Za-z]+$/.test(pyName)) {
        return false;
      }
      return true;
    },
    sailDateChangedBir(value) {
      if (value && value.length > 0) {
        this.DateOfBirth = value
      }
      this.isCalendarShowBir = false
    },
    sailDateChanged(value) {
      if (value && value.length > 0) {
        this.sailDate = value
      }
      this.isCalendarShow = false
    },
    showLoginPopup(callback) {
      this.loginCallback = callback
    },
    onLoginSuccessHandler() {
      if (this.loginCallback) {
        this.loginCallback()
        this.loginCallback = null
      }
    },
    async onCaptchaSuccess(captchaRes) {
      if(!this.goToLogin()) return;
      try {
        this.isCaptchaAllow = true;
        this.captchaVerifyParam = captchaRes
        await this.submitBookingSearch();
      } finally {
        this.captchaReset = (new Date()).getTime().toString();
      }
    },
    onCaptchaFail() {
      this.isCaptchaAllow = false
    },
    onCaptchaReset() {
      this.isCaptchaAllow = false
    }
  },
  computed: {
    rowSearchLink() {
      return process.env.VUE_APP_BASE_URL + `/Rccl.Campaign/RedirectToTui?redirectUrl=${process.env.VUE_APP_TUI_URL}/Booking/BookingSearch`
    },
    today() {
      return moment().format('yyyy-MM-DD')
    }

  }
}
</script>

<style lang="less" scoped>
/* GLOBAL STYLES
-------------------------------------------------- */
/* Padding below the footer and lighter body text */
/* RESPONSIVE CSS
------------------------------------------------------------------------------------------------- */
/* common */
.queryOrder_page {
  background: #f0f0f0;
  padding-bottom: 250px;

  .calendar {
    left: 100px;
  }
}

.queryOrder_txtDarkBlue {
  font-size: 32px;
  color: #081259;
  font-weight: bold;
  height: 40px;
  line-height: 40px;
}

.queryOrder__mainCon_red {
  color: red;
}

.queryOrder__topCon {
  text-align: center;
  margin-top: 40px;
}

.queryOrder__topCon_line {
  width: 160px;
  height: 1px;
  border: 1px solid #fbc300;
  display: inline-block;
  vertical-align: middle;
}

.queryOrder__mainCon {
  background: #fff;
  margin-top: 28px;
  padding-left: 40px;
  padding-bottom: 40px;
}

.queryOrder__mainCon_title {
  font-size: 18px;
  padding-top: 30px;
}

.queryOrder__mainCon_title p {
  height: 40px;
  line-height: 20px;
}

.queryOrder__mainCon_attention {
  line-height: 20px;
}

.queryOrder__mainCon ul li {
  position: relative;
  width: 76%;
  height: 40px;
  line-height: 40px;
  margin: 20px 0px;
}

.queryOrder__mainCon_input {
  width: 60%;
  float: left;
  margin-left: 0;
  height: 90%;
  border: 2px solid #dedfe1;
  border-radius: 5px;
  overflow: hidden;
}

.queryOrder__mainCon_input p {
  line-height: 34px;
  height: 34px;
  text-align: right;
  margin-left: 5px;
  float: left;
  color: #777;
  font-weight: 900;
  font-size: 14px;
}

.queryOrder__mainCon_input input {
  float: right;
}

.queryOrder__mainCon_input input,
.queryOrder__mainCon_input select {
  width: 68%;
  color: #777;
  height: 25px;
  border: 0;
  line-height: 25px;
  font-size: 12px;
  margin: 6px 1%;
  outline: none;
}

.queryOrder__mainCon_liCare {
  margin-left: 10px;
  font-size: 12px;
  display: inline-block;
  margin-bottom: 0;
}

.queryOrder__shipSelect {

}


.queryOrder__mainCon_input select {
  border: none;
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  background: none;
  /*padding-right: 32px;*/
  background: url("https://resource.rcclchina.com.cn/bookingPay/orderquery-select.png") no-repeat scroll right center transparent;
  cursor: pointer;
  margin-left: 36px;
}

.queryOrder__mainCon_input select option {
  padding: 4px;
}

.queryOrder__mainCon_input select::-ms-expand {
  display: none;
}

.queryOrder__mainCon_submit {
  width: 123px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  background: url("https://resource.rcclchina.com.cn/bookingPay/orderQuery-button.png") no-repeat;
  display: block;
  font-weight: 900;
  margin-left: 432px;
  color: #041555;
  cursor: pointer;
}

#sailDateCalendar {
  margin-left: 100px;
}


.login-remindTxt {
  margin-top: 22px;
  font-size: 13px;
}

.login-remindTxt span {
  color: #fcc400;
}

.loginPromot {
  margin-top: 10px;
  font-size: 13px;
}

.sin_container {
  margin-top: 10px;
  font-size: 12px;
}

.sin_container a {
  color: #edb000;
}

.sin_container span {
  vertical-align: middle;
  color: #000;
  font-size: 13px;
}


/*新增样式*/
#queryOrder__form {
  position: relative;
}

/*二维码样式*/
.queryOrder__Wechat {
  position: absolute;
  top: 10px;
  right: 40px;
}

.queryOrder__Wechat p {
  color: #777;
  font-weight: 900;
  font-size: 14px;
}

.queryOrder__WechatPic {
  width: 172px;
  height: 172px;
  margin: 0 auto;
}

.queryOrder__WechatPic img {
  width: 100%;
}

ul.dropdown-menu li {
  margin: 0px;
}

#queryOrder__ship {
  float: right;
}

/**** 隐私政策 ****/
.sin_container .input__top img {
  width: 17px;
  height: 17px;
  cursor: pointer;
}

.sin_container .input__top.isAgreePushMsg img:nth-child(1) {
  display: none;
}

.sin_container .input__top.isAgreePushMsg img:nth-child(2) {
  display: inline-block;
}

.sin_container .input__top.isAgreePushMsg.active img:nth-child(1) {
  display: inline-block;
}

.sin_container .input__top.isAgreePushMsg.active img:nth-child(2) {
  display: none;
}

.sin_container .input__top.isAgreePrivacy img:nth-child(1) {
  display: none;
}

.sin_container .input__top.isAgreePrivacy img:nth-child(2) {
  display: inline-block;
}

.sin_container .input__top.isAgreePrivacy.active img:nth-child(1) {
  display: inline-block;
}

.sin_container .input__top.isAgreePrivacy.active img:nth-child(2) {
  display: none;
}


/**航线切换**/
.cruise-switch-container {
  .cruise-switch-text {
    margin-left: 5px;
  }
}

.cruise-switch-container .cruise-switch-wrapper {
  display: inline-block;
  vertical-align: middle;
  font-size: 18px;
  cursor: pointer;
}

.cruise-switch-container .cruise-switch-wrapper > div {
  display: inline-block;
  vertical-align: middle;
}

.cruise-switch-container .cruise-switch-wrapper .cruise-switch {
  width: 15px;
}

.cruise-switch-container .cruise-switch-wrapper .cruise-switch img {
  width: 100%;
}

.cruise-switch-container .cruise-row {
  margin-left: 30px;
}

.groupType-select {
  color: #777;
  font-weight: 900;
  font-size: 14px;
  display: inline-block;
}

.btn-group .dropdown-menu li {
  width: 100%;
  cursor: pointer;
}

.cruise-switch-unselected2{
  width: 15px;
  height: 15px;
  border: 1px solid #febc10;
  border-radius: 50%;
  background-color: transparent;
  box-sizing: border-box;
}

.margin-top-0{
  margin-top: 0 !important;
}

.order-box{
  margin: 0 !important;
}
.order-box-item{
  width: 60%;
  display: flex;
  align-items: self-start;
  justify-content: space-between;
}
.order-box-item-title{
  //height: 34px;
  margin-left: 5px;
  color: #575757;
  font-weight: 900;
  font-size: 14px;
  //line-height: 1;
}
.order-box-item-right{
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  line-height: 1;
  font-size: 12px;
  color: #9B9B9B;
}
.order-box-item-right > a{
  display: block;
  font-weight: normal;
  font-size: 14px;
  color: #3279B7;
  text-align: left;
  font-style: normal;
  line-height: 1;
  margin-bottom: 4px;
}
.order-box-item-right > a:hover {
    color: #3279B7; /* 鼠标移入时颜色不变 */
}


</style>
